"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@rmwc/icon/icon.css");
